import { Box, Card, CardContent, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { colors } from "../../theme/theme";
import ColorSelector from "./ColorSelector";
import { logUserAction } from "../../utils/analytics";

const NewOnSaleProductCard = ({
  product,
  noColor = false,
}) => {
  const navigate = useNavigate();

  const isSearchPage = window.location.pathname === "/search";
  const query = isSearchPage ? localStorage.getItem("query") : null;

  if (!product) return null;

  return (
    <Card
      onClick={() => {
        logUserAction({
          action: "product_click",
          data: {
            product_id: product.product_id || null,
            product_title: product.title || null,
            brand: product.brand || null,
            product_price:
              product?.price?.discounted ||
              product?.price?.original ||
              null,
            currency: product?.price?.currency || null,
            product_image: product?.image_url || null,
          },
          timestamp: new Date().toISOString(),
        });
        navigate("/product", {
          state: {
            product: product,
            similarProducts: [product],
            searchQuery: query,
          },
        });
      }}
      sx={{
        width: "100%",
        borderRadius: noColor ? "12px" : "16px",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        border: "none",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#fff",
        transition: "all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1)",
        "&:hover": {
          boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
          transform: "translateY(-6px)",
          "& .product-img": {
            transform: "scale(1.05)",
          },
        },
        "&:active": {
          transform: "translateY(-2px)",
        },
        cursor: "pointer",
        height: "100%",
      }}
    >
      <Box
                  sx={{
                    position: "relative",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                  }}
                >
                  <Box
                    component="img"
                    src={product?.image_url}
                    onError={(e) => {
                      const fallbackImage = product?.images?.[0];
                      if (fallbackImage && !e.target.dataset.triedFallback) {
                        e.target.dataset.triedFallback = "true";
                        e.target.src = fallbackImage;
                      } else {
                        e.target.onerror = null;
                        e.target.src = require("../../assets/images/no_image.png");
                      }
                    }}
                    loading="lazy"
                    alt=""
                    className="product-img"
                    sx={{
                      objectFit: "cover",
                      objectPosition: "top",
                      height: { xs: "220px", sm: "300px", md: noColor ? "380px" : "400px" },
                      width: "100%",
                      transition: "transform 0.6s cubic-bezier(0.165, 0.84, 0.44, 1)",
                    }}
                  />
                </Box>

                <CardContent
                  className="bg-white"
                  sx={{
                    p: noColor ? 2 : 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 0.75,
                    flexGrow: 1,
                  }}
                >
                  {product?.brand && (
                    <Typography
                      sx={{
                        fontSize: "11px",
                        color: "#888",
                        fontFamily: "Poppins-Medium",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        mb: -0.5,
                      }}
                    >
                      {product.brand}
                    </Typography>
                  )}
                  <Typography
                    variant="h6"
                    sx={{
                      fontSize: noColor ? "14px" : "14px",
                      color: "#1a1a1a",
                      fontFamily: "Poppins-Medium",
                      fontWeight: "500",
                      lineHeight: 1.4,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      minHeight: "40px",
                    }}
                  >
                    {product?.title}
                  </Typography>

                  {!noColor && <ColorSelector small />}

                  <Box sx={{ mt: "auto", pt: 0.5 }}>
                    <Typography
                      sx={{
                      fontSize: noColor ? "16px" : "15px",
                      color: product?.price?.discounted ? "#E53935" : "#1a1a1a",
                      fontFamily: "Poppins-SemiBold",
                      fontWeight: "700",
                      letterSpacing: "-0.01em",
                    }}
                    >
                      {product?.price?.discounted ? (
                        <>
                          {product.price.discounted}{" "}
                          <Typography
                            component="span"
                            sx={{
                              fontSize: noColor ? "13px" : "12px",
                              color: "#666",
                              fontFamily: "Poppins-Regular",
                              fontWeight: "400",
                            }}
                          >
                            {product.price.currency || ""}
                          </Typography>
                          {product.price.original && (
                            <Typography
                              component="span"
                              sx={{
                                fontSize: noColor ? "13px" : "12px",
                                color: "#999",
                                textDecoration: "line-through",
                                ml: 1,
                                fontFamily: "Poppins-Regular",
                                fontWeight: "400",
                              }}
                            >
                              {product.price.original}{" "}
                              {product.price.currency || ""}
                            </Typography>
                          )}
                        </>
                      ) : (
                        <>
                          {product?.price?.original || "N/A"}{" "}
                          <Typography
                            component="span"
                            sx={{
                              fontSize: noColor ? "13px" : "12px",
                              color: "#666",
                              fontFamily: "Poppins-Regular",
                              fontWeight: "400",
                            }}
                          >
                            {product?.price?.currency || ""}
                          </Typography>
                        </>
                      )}
                    </Typography>
                  </Box>
                </CardContent>
    </Card>
  );
};

export default NewOnSaleProductCard;
